module.exports = __webpack_public_path__ + "img/icon_qrqm.76155351.png";